import {
  faBan,
  faCheckCircle,
  faEdit,
  faEnvelope,
  faPen,
  faSave,
  faShoppingCart,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import moment from "moment";
import {
  stringify as objectToQueryParams,
  parse as parseQueryParams
} from "query-string";
import { default as React, default as React } from "react";
import { withRouter } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  FormText,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  UncontrolledTooltip
} from "reactstrap";
import {
  PARTNER_MEMB_ACTIVE_STATUS,
  PARTNER_MEMB_CANCELLED_STATUS,
  PARTNER_MEMB_INACTIVE_STATUS,
  PARTNER_MEMB_PASIVE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS,
  PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS,
  PARTNER_MEMB_PENDIENTE_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS,
  PARTNER_MEMB_TRASPASSED_STATUS
} from "../../../../src/utils/constants";
import { parseArrayToDropdownOptions } from "../../../../src/utils/helpers";
import PartnerSelector from "../../../People/containers/PartnerSelector";
import BaseInput from "../../../toolkit/baseInput";
import { userHasPermission } from "../../../utils/accessTree";
import { handleRequestError } from "../../../utils/helpers";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import permissionCodes from "../../../utils/permissionCodes";
import {
  activate,
  associateAltPromotion,
  associatePromotion,
  createPartnerMembershipReferredCodes,
  deleteExtranjerosLicenciaActual,
  deletePartnerMembershipReferredCode,
  getComprobarConvenio,
  getCrm1Benefits,
  getDiscountCodesFitkidz,
  getExtranjeros,
  getExtranjerosLicenciaActual,
  getPartnerMembershipAvailableReferredCodes,
  getPartnerMembershipByPartnerId,
  getPartnerMembershipDocumentInstancesRequest,
  getPartnerMembershipFitKidzEvidence,
  getPartnerMembershipMaintenacesDetailReport,
  getPartnerMembershipPreviousMaintenances,
  getPartnerMembershipReferred,
  getPartnerMembershipVacationFees,
  getPartnersClubAccessInfo,
  putDesasociarConvenio,
  sendSelfOnboardingMail,
  updatePartnerMembershipStatus
} from "../../actions/partners";
import { Props, State } from "./interfaces";
import s from "./styles.scss";
import TabAnnuitiesQuote from "./tabAnnuitiesQuote";
import TabBankCards from "./tabBankCards/tabBankCards";
import TabDiscountCodes from "./tabDiscountCodes";
import TabDocuments from "./tabDocuments";
import TabHistoryAutCharge from "./tabHistoryAutCharge";
import TabMessages from "./tabMessages/index";
import TabMovements from "./tabMovements";
import TabPartners from "./tabPartners";
import TabPartnersIngress from "./tabPartnersIngress";
import TabPayments from "./tabPayments";
import TabReactivation from "./tabReactivation/tabReactivation";
import TabRequotation from "./tabRequotation/tabRequotation";
import TabSurveys from "./tabSurveys";
import TabTransact from "./tabTransacts/tabTransact";

import { getMaintenancesAvailableForAnnuities } from "../../actions/annuities";
import { getPartnerMembershipInvoicesToReturnRequest } from "../../actions/billing";
import {
  getBanksRequest,
  getCardTypesRequest,
  getMaintenancesByMembershipForQuotation,
  getMembershipsTypesByClubAvailableToSellRequest,
  getSellersCatalog,
  getSurveyTypesRequest
} from "../../actions/catalogs";
import {
  getActualQuoteRequest,
  getDiscountCodes,
  getMessagesRequest,
  getPaymentMethodsRequest,
  searchMovementsByClubAndMembershipRequest
} from "../../actions/partners";
import { getHistAutChargesRequest } from "../../actions/products";
import DatePicker from "../common/DatePicker";
import SideActionButton from "../common/sideActionButton";
import TabBenefitsCrm1 from "./tabBenefitsCrm1";
import TabHistoryCrm1 from "./tabHistoryCrm1";

// TODO: REDUX
import axios from "axios";
import BaseButtonWithIconAndTooltip from "../../../toolkit/baseButtonWithIconAndTooltip";
import BasicSpinner from "../../../toolkit/basicSpinner";
import ModalFrame from "../../../toolkit/modalFrame";
import constants from "../../../utils/constants";
import { getPromotionsFilteredRequest } from "../../actions/promotions";
import HomologarPropietarioModal from "../../containers/personaReferencia/homologarPropietario";
import HomologarTitularMayorModal from "../../containers/personaReferencia/homologarTitularMayor";
import ConfirmModal from "../common/confirmModal/confirmModal";
import AlternateClubAssociationModal from "./alternateClubAssociationModal/alternateClubAssociationModal";
import PromotionAssociationModal from "./promotionAssociationModal/promotionAssociationModal";
import TabBinnacle from "./tabBinnacle";
import TabDescuentosDirectos from "./tabDescuentosDirectos";
import TabFitKidz from "./tabFitKidz";
import { TabLicenciaExtranjeros } from "./tabLicenciaExtranjeros";
import TabMaintenancesDetailReport from "./tabMaintenancesDetail";
import TabReferred from "./tabReferred";
import TabVacationFees from "./tabVacationFees";

const renderChangeStatusButton = (
  idMembresiaSocio,
  newStatus,
  buttonId,
  tooltipTitle,
  icon,
  f
) => {
  return (
    <a
      id={buttonId}
      className="ml-3"
      style={{ cursor: "pointer" }}
      onClick={e => {
        e.preventDefault();
        updatePartnerMembershipStatus(idMembresiaSocio, newStatus)
          .then(() => {
            f();
          })
          .catch(handleRequestError);
      }}
    >
      <FontAwesomeIcon icon={icon} />
      <UncontrolledTooltip placement="top" target={buttonId}>
        {tooltipTitle}
      </UncontrolledTooltip>
    </a>
  );
};

const ESTATUS_MEMBRESIA_BLOQUEO = [
  PARTNER_MEMB_CANCELLED_STATUS,
  PARTNER_MEMB_TRASPASSED_STATUS
];

const ESTATUS_MEMBRESIA_BLOQUEO_REACTIVACION = [
  PARTNER_MEMB_PASIVE_STATUS,
  PARTNER_MEMB_INACTIVE_STATUS
];

const ESTATUS_MEMBRESIA_BLOQUEO_NUEVO_FLUJO = [
  PARTNER_MEMB_PENDIENTE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS,
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS,
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS
];

const ESTATUS_MEMBRESIA_PENDIENTE = [
  PARTNER_MEMB_PENDIENTE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS
];

// Constante para la promoción Friends & Family
const FRIENDS_AND_FAMILY_PROMOTION_ID: any = 10006125;

class Partners extends React.Component<Props, State> {
  state = {
    filters: {
      idClub: "",
      idPublico: ""
    },
    idMembresiaSocio: "",
    activeTab: "1",
    partner: null,
    users: [],
    documentInstances: [],

    banks: [],
    paymentMethods: [],
    cardTypes: [],
    surveyTypes: [],

    annuitiesAvailableMaintenances: [],
    discountCodes: [],
    invoicesToReturn: [],
    listHistoryAutCharges: [],
    futureChargesQuote: null,
    messagesByMembresia: [],
    movementsList: [],
    actualQuote: null,
    currentAgreements: [],
    partnerMembershipDocumentInstances: [],
    fechaAdquisicion: null as any,
    crm1BenefitsList: [],
    convenioMessage: null,
    vacationFees: [],
    maintenancesDetail: [],
    maintenancesDetailSearching: false,
    referredDetail: [],
    referredCodesDetail: [],
    previousMaintenancesList: [],
    directMaintenancesList: [],
    directMembershipsList: [],

    // Licencias de extranjeros
    licencia: null,
    licenciaCancelacion: false,
    extranjeros: [],

    partnersClubAccessInfo: [],

    mttoConvenio: [],
    modalMttoConvenio: false,

    fitKidzEvidencesList: [],
    fitKidzDiscountsCodesList: [],

    isPromotionAssociationModalOpen: false,
    isAlternateClubAssociationModalOpen: false,
    allowedPromotions: [],

    isHomologarTitularMayorModalOpen: false,
    isHomologarPropietarioModalOpen: false,

    searching: false,
    modalMensajeAlerta: false,
    modalMensajeAlertaMessage: "",
    modalMensajeAlertaTitulo: "",
    modalVetadoVisible: false,
    estaVetado: false,
    sociosVetados: []
  };

  searchParner = filters => {
    this.setState({
      filters: { ...filters },
      convenioMessage: null
    });

    this.props
      .getPartner(filters)
      .then(async ({ value: { data } }) => {
        this.props.history.push(
          `/membresias-socios/${data.idMembresiaSocio}?${objectToQueryParams(
            filters
          )}`
        );
        this.setState({ partner: data, searching: false });

        /*if (data.vetado) {
          this.setState({ modalVetadoVisible: true });
          this.setState({ estaVetado: data.vetado });

          setTimeout(() => {
            this.toggleTab("8");
            this.getPartnerMembershipMessages();
          }, 50);
        }*/

        try {
          const responseLicencia = await getExtranjerosLicenciaActual(
            data.idMembresiaSocio
          );
          if (responseLicencia.data && responseLicencia.data.fechaInicio) {
            this.setState({
              licencia: responseLicencia.data
            });
          } else {
            this.setState({
              licencia: null
            });
          }

          const responseExtranjeros = await getExtranjeros(
            data.idMembresiaSocio
          );
          if (responseExtranjeros.data) {
            this.setState({
              extranjeros: responseExtranjeros.data
            });
          }

          if (data.idConvenio) {
            await getComprobarConvenio(data.idMembresiaSocio);
            this.setState({
              convenioMessage: null
            });
          }

          //this.getInitialPartnerMembershipMessages();
        } catch (error) {
          this.setState({
            convenioMessage:
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : null
          });

          this.setState({
            licencia: null
          });
        }
      })
      .catch(error => {
        this.setState({ searching: false });
      });
  };

  refreshPartner = () => {
    const { idPublico, idClub } = parseQueryParams(this.props.location.search);

    if (idPublico && idClub) {
      this.searchParner({
        idPublico,
        idClub
      });
    }
  };

  componentDidMount() {
    const { idPublico, idClub } = parseQueryParams(this.props.location.search);

    if (idPublico && idClub) {
      this.searchParner({
        idPublico,
        idClub
      });
    } else {
      const { filters } = this.state;
      if (
        !filters.idClub &&
        this.props.userContext &&
        !!this.props.userContext.clubSessionId
      ) {
        filters.idClub = this.props.userContext.clubSessionId;
        this.setState({ filters: { ...filters } });
      }
    }
  }

  componentDidUpdate(prevProps): void {
    if (prevProps.agreements != this.props.agreements) {
      this.setState({
        currentAgreements: this.props.agreements
      });
    }
    if (!prevProps.partnerCreated && this.props.partnerCreated) {
      this.refreshPartner();
    }

    if (!prevProps.partnerCreated && this.props.partnerCreated) {
      this.refreshPartner();
    }

    if (prevProps.partnersMembership != this.props.partnersMembership) {
      const socios = this.props.partnersMembership || [];
      const sociosVetados = socios.filter(p => p.vetado);
      const estaVetado = sociosVetados.length > 0;

      this.setState({
        modalVetadoVisible: estaVetado,
        sociosVetados,
        estaVetado: estaVetado
      });

      if (estaVetado) {
        this.getPartnerMembershipMessages();
      }
    }
  }

  search = () => {
    infoNotification("Buscando membresía...");
    this.setState({ searching: true });
    this.clearForNewSearch();
    this.toggleTab("1");
    this.searchParner(this.state.filters);
  };

  clearForNewSearch = () => {
    this.setState({
      paymentMethods: [],
      annuitiesAvailableMaintenances: [],
      discountCodes: [],
      invoicesToReturn: [],
      listHistoryAutCharges: [],
      messagesByMembresia: [],
      movementsList: [],
      actualQuote: null,
      currentAgreements: [],
      partnerMembershipDocumentInstances: [],
      crm1BenefitsList: [],
      vacationFees: [],
      maintenancesDetail: [],
      maintenancesDetailSearching: false,
      referredDetail: [],
      referredCodesDetail: [],
      previousMaintenancesList: [],
      directMaintenancesList: [],
      directMembershipsList: [],
      partnersClubAccessInfo: [],
      fitKidzEvidencesList: [],
      fitKidzDiscountsCodesList: []
    });
  };

  onChangeFilter = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const filters = {
          ...this.state.filters,
          [fieldName]: value
        };
        return { ...state, filters };
      });
    };
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  personChanged = person => {
    const idPersona = !!person ? person.personaId : "";
    getPartnerMembershipByPartnerId(idPersona)
      .then(({ data }) => {
        const { filters } = this.state;
        filters.idClub = data.idClubBase;
        filters.idPublico = data.idPublico;

        this.setState({ filters });
        this.search();
      })
      .catch(handleRequestError);
  };
  // cambio de traspaso de membresia, se busca el club y el numero de membresia en la descripcion del traspaso
  searchTransferredMembership = event => {
    event.preventDefault();

    const { partner } = this.props;
    if (!partner || !partner.descripcionTraspaso) return;

    const match = partner.descripcionTraspaso.match(
      /al club\s+(.+?)\s+con\s+número\s+(\d+)/
    );
    if (!match) return;

    const clubName = match[1];
    const membershipNumber = match[2];
    const club = this.getOnlyMigratedClubs().find(c => c.nombre === clubName);

    if (!club) {
      errorNotification(`No se encontró el club ${clubName}`);
      return;
    }

    this.searchParner({
      idClub: club.clubId,
      idPublico: membershipNumber
    });
  };

  //-----------------------------------------------------------------------------
  getBanksCatalog = () => {
    const { banks } = this.state;
    if (banks == null || banks.length == 0) {
      getBanksRequest()
        .then(({ data }) => {
          this.setState({ banks: [...data] });
        })
        .catch(handleRequestError);
    }
  };

  getPaymentMethods = () => {
    const { paymentMethods } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    // if (paymentMethods == null || paymentMethods.length == 0) {
    getPaymentMethodsRequest(idMembresiaSocio)
      .then(({ data }) => {
        this.setState({ paymentMethods: [...data] });
      })
      .catch(handleRequestError);
    // }
  };

  getMembershipDiscountCodes = () => {
    const { discountCodes } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    if (discountCodes == null || discountCodes.length == 0) {
      getDiscountCodes(idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ discountCodes: data });
        })
        .catch(handleRequestError);
    }
  };

  getAnnuitiesAvailableMaintenaces = () => {
    const { annuitiesAvailableMaintenances } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    if (
      annuitiesAvailableMaintenances == null ||
      annuitiesAvailableMaintenances.length == 0
    ) {
      getMaintenancesAvailableForAnnuities(idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ annuitiesAvailableMaintenances: [...data] });
        })
        .catch(handleRequestError);
    }
  };

  getAnnuitiesUsers = () => {
    getSellersCatalog()
      .then(({ data }) => {
        this.setState({ users: data });
      })
      .catch(handleRequestError);
  };

  getCardTypes = () => {
    const { cardTypes } = this.state;

    if (cardTypes == null || cardTypes.length == 0) {
      getCardTypesRequest()
        .then(({ data }) => {
          this.setState({ cardTypes: data });
        })
        .catch(handleRequestError);
    }
  };

  getInvoicesToReturn = () => {
    const { invoicesToReturn } = this.state;

    if (invoicesToReturn == null || invoicesToReturn.length == 0) {
      const { idPublico, idClub } = parseQueryParams(
        this.props.location.search
      );

      getPartnerMembershipInvoicesToReturnRequest(idClub, idPublico)
        .then(({ data }) => {
          this.setState({ invoicesToReturn: data });
        })
        .catch(handleRequestError);
    }
  };

  getAutomaticChargesRecord = () => {
    const { listHistoryAutCharges } = this.state;

    if (listHistoryAutCharges == null || listHistoryAutCharges.length == 0) {
      const { idPublico, idClub } = parseQueryParams(
        this.props.location.search
      );

      getHistAutChargesRequest(idClub, idPublico)
        .then(({ data }) => {
          this.setState({ listHistoryAutCharges: data });
        })
        .catch(handleRequestError);
    }
  };

  getInitialPartnerMembershipMessages = () => {
    const { messagesByMembresia } = this.state;

    if (messagesByMembresia == null || messagesByMembresia.length == 0) {
      const { idMembresiaSocio } = this.props.partner;

      getMessagesRequest(idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ messagesByMembresia: data });

          if ((data || []).length > 0) {
            const messagesAlert = data.filter(x => !!x.alerta && !!x.activo);
            if (messagesAlert.length > 0) {
              this.setState({
                modalMensajeAlerta: true,
                modalMensajeAlertaMessage: messagesAlert[0].descripcion,
                modalMensajeAlertaTitulo: messagesAlert[0].titulo
              });
            }
          }
        })
        .catch(handleRequestError);
    }
  };

  getPartnerMembershipMessages = () => {
    const { messagesByMembresia } = this.state;

    if (messagesByMembresia == null || messagesByMembresia.length == 0) {
      const { idMembresiaSocio } = this.props.partner;

      getMessagesRequest(idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ messagesByMembresia: data });
        })
        .catch(handleRequestError);
    }
  };

  getMovements = () => {
    const { movementsList } = this.state;

    if (movementsList == null || movementsList.length == 0) {
      const {
        idPublico: membresiaSocioIdPublico,
        idClub: clubId
      } = parseQueryParams(this.props.location.search);

      searchMovementsByClubAndMembershipRequest({
        clubId,
        membresiaSocioIdPublico
      })
        .then(({ data }) => {
          this.setState({ movementsList: data });
        })
        .catch(handleRequestError);
    }
  };

  getCurrentQuote = () => {
    const { actualQuote } = this.state;

    if (actualQuote == null) {
      const { idPublico, idClub } = parseQueryParams(
        this.props.location.search
      );

      getActualQuoteRequest(idPublico, idClub)
        .then(({ data }) => {
          this.setState({ actualQuote: data });
        })
        .catch(handleRequestError);
    }
  };

  getCurrentAgreements = () => {
    const { currentAgreements } = this.state;

    if (currentAgreements == null || currentAgreements.length == 0) {
      this.props.getEmpresasActivas({
        clubId: this.props.partner.idClubBase,
        mantenimientoId: this.props.partner.idMantenimiento,
        membresiaId: this.props.partner.idMembresia
      });
    }
  };

  getSurveyTypes = () => {
    const { surveyTypes } = this.state;

    if (surveyTypes == null || surveyTypes.length == 0) {
      getSurveyTypesRequest()
        .then(({ data }) => {
          this.setState({ surveyTypes: data });
        })
        .catch(handleRequestError);
    }
  };

  getPartnerMembershipDocumentInstances = () => {
    getPartnerMembershipDocumentInstancesRequest(
      this.props.partner.idMembresiaSocio
    )
      .then(({ data }) => {
        this.setState({ partnerMembershipDocumentInstances: data });
      })
      .catch(handleRequestError);
  };

  getCrm1Benefits = () => {
    const { crm1BenefitsList } = this.state;

    if (crm1BenefitsList == null || crm1BenefitsList.length == 0) {
      getCrm1Benefits(this.props.partner.idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ crm1BenefitsList: data });
        })
        .catch(handleRequestError);
    }
  };

  getMembershipVacationFees = () => {
    const { vacationFees } = this.state;

    if (vacationFees == null || vacationFees.length == 0) {
      getPartnerMembershipVacationFees(this.props.partner.idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ vacationFees: data });
        })
        .catch(handleRequestError);
    }
  };

  getMembershipMaintenancesDetail = () => {
    const { maintenancesDetail } = this.state;

    if (maintenancesDetail == null || maintenancesDetail.length == 0) {
      this.setState({ maintenancesDetailSearching: true });

      getPartnerMembershipMaintenacesDetailReport(
        this.props.partner.idMembresiaSocio
      )
        .then(({ data }) => {
          const result = {};
          (data || []).forEach(item => {
            const { personaId, personaNombre } = item;
            if (!result[personaId]) {
              result[personaId] = {
                personaId,
                personaNombre,
                mantenimientos: [item]
              };
            } else {
              result[personaId].mantenimientos = [
                ...result[personaId].mantenimientos,
                item
              ];
            }
          });

          const partnersMaintenances = [];

          Object.keys(result).forEach(key => {
            partnersMaintenances.push(result[key]);
          });

          this.setState({
            maintenancesDetail: partnersMaintenances,
            maintenancesDetailSearching: false
          });
        })
        .catch(handleRequestError);
    }
  };

  getMembershipReferredDetail = () => {
    const { referredDetail } = this.state;

    if (referredDetail == null || referredDetail.length == 0) {
      getPartnerMembershipReferred(this.props.partner.idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ referredDetail: data });
        })
        .catch(handleRequestError);
    }
  };

  getMembershipReferredCodesDetail = () => {
    const { referredCodesDetail } = this.state;

    if (referredCodesDetail == null || referredCodesDetail.length == 0) {
      getPartnerMembershipAvailableReferredCodes(
        this.props.partner.idMembresiaSocio
      )
        .then(({ data }) => {
          this.setState({ referredCodesDetail: data });
        })
        .catch(handleRequestError);
    }
  };

  createMembershipReferredCodes = () => {
    createPartnerMembershipReferredCodes(this.props.partner.idMembresiaSocio)
      .then(async () => {
        await this.invalidateStateValue("referredCodesDetail", []);
        await this.getMembershipReferredCodesDetail();
      })
      .catch(handleRequestError);
  };

  deleteMembershipReferredCode = (codigoReferidoId: number) => {
    deletePartnerMembershipReferredCode(codigoReferidoId)
      .then(async () => {
        successNotification("Código de referido eliminado correctamente");
        await this.invalidateStateValue("referredCodesDetail", []);
        await this.invalidateStateValue("referredDetail", []);
        await this.getMembershipReferredCodesDetail();
        await this.getMembershipReferredDetail();
      })
      .catch(handleRequestError);
  };

  getPartnersClubAccessInfoXX = () => {
    const { partnersClubAccessInfo } = this.state;

    if (partnersClubAccessInfo == null || partnersClubAccessInfo.length == 0) {
      getPartnersClubAccessInfo(this.props.partner.idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ partnersClubAccessInfo: data });
        })
        .catch(handleRequestError);
    }
  };

  getFitKidzEvidencesList = () => {
    const { fitKidzEvidencesList } = this.state;

    if (fitKidzEvidencesList == null || fitKidzEvidencesList.length == 0) {
      getPartnerMembershipFitKidzEvidence(this.props.partner.idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ fitKidzEvidencesList: data });
        })
        .catch(handleRequestError);
    }
  };

  getFitKidzDiscountsCodesList = () => {
    const { fitKidzDiscountsCodesList } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    if (
      fitKidzDiscountsCodesList == null ||
      fitKidzDiscountsCodesList.length == 0
    ) {
      getDiscountCodesFitkidz(idMembresiaSocio)
        .then(({ data }) => {
          this.setState({ fitKidzDiscountsCodesList: data });
        })
        .catch(handleRequestError);
    }
  };

  invalidateStateValue = (fieldName, value) => {
    this.setState({ ...this.state, [fieldName]: value });
  };

  getOnlyMigratedClubs = () => {
    return (this.props.clubs || []).filter(c => !!c.migradoCrm2);
  };

  isMembershipBlocked = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_BLOQUEO.includes(this.props.partner.estatusMembresia)
    );
  };

  isMembershipBlockedReactivacion = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_BLOQUEO_REACTIVACION.includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  isMembershipBlockedNuevoFlujoVenta = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_BLOQUEO_NUEVO_FLUJO.includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  isMembershipBlockedPresale = () => {
    return !!this.props.partner && !!this.props.partner.preventa;
  };

  isMembershipPendienteStatus = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_PENDIENTE.includes(this.props.partner.estatusMembresia)
    );
  };

  isMembershipPendienteConAnualidadStatus = () => {
    return (
      !!this.props.partner &&
      PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS ==
        this.props.partner.estatusMembresia
    );
  };

  isMembershipTipoFlujoVenta = () => {
    return (
      !!this.props.partner &&
      this.props.partner.tipoModalidadFlujoVenta == "VENTA"
    );
  };

  isMembershipTipoFlujoReactivacion = () => {
    return (
      !!this.props.partner &&
      this.props.partner.tipoModalidadFlujoVenta == "REACTIVACION"
    );
  };

  // Verifica si la membresía tiene la promoción Friends & Family
  isFriendsAndFamilyPromotion = () => {
    return (
      !!this.props.partner &&
      this.props.partner.idPromocion == FRIENDS_AND_FAMILY_PROMOTION_ID
    );
  };

  // Verifica si el titular es mayor de edad
  isTitularMayorDeEdad = () => {
    if (!this.props.partner) return false;

    // Usar el campo esMayorDeEdad que viene del backend
    return this.props.partner.esMayorDeEdad === true;
  };

  // Verifica si se debe mostrar el botón de homologar titular
  shouldShowHomologarButton = () => {
    if (
      !this.props.partner ||
      !userHasPermission(permissionCodes.HOMOLOGACION_PROSPECTO_MAYORIA_EDAD)
    ) {
      return false;
    }

    const { idPropietario, idPersona, estatusMembresia } = this.props.partner;

    // Condiciones:
    // 1. idPropietario y idPersona son diferentes
    // 2. El titular es mayor de edad
    // 3. La membresía está en estatus INACTIVA
    return (
      idPropietario !== idPersona &&
      this.isTitularMayorDeEdad() &&
      estatusMembresia === PARTNER_MEMB_INACTIVE_STATUS
    );
  };

  // Verifica si se debe mostrar el botón de homologar propietario
  shouldShowHomologarPropietarioButton = () => {
    if (
      !this.props.partner ||
      !userHasPermission(permissionCodes.HOMOLOGACION_PROSPECTO_CURP_DUPLICADA)
    ) {
      return false;
    }

    const {
      idPropietario,
      idPersona,
      estatusMembresia,
      propietarioCurpAprobada
    } = this.props.partner;

    // Condiciones:
    // 1. idPropietario y idPersona son diferentes
    // 2. La membresía está en estatus INACTIVA
    // 3. La CURP del propietario NO está aprobada
    return (
      idPropietario !== idPersona &&
      estatusMembresia === PARTNER_MEMB_INACTIVE_STATUS &&
      propietarioCurpAprobada !== true
    );
  };

  // Abre el modal de homologación de titular mayor de edad
  handleHomologarTitular = () => {
    this.setState({ isHomologarTitularMayorModalOpen: true });
  };

  // Cierra el modal de homologación
  handleCloseHomologarTitularModal = () => {
    this.setState({ isHomologarTitularMayorModalOpen: false });
  };

  // Callback cuando la homologación es exitosa
  handleHomologarTitularSuccess = () => {
    this.setState({ isHomologarTitularMayorModalOpen: false });
    this.refreshPartner();
  };

  // Abre el modal de homologación de propietario
  handleHomologarPropietario = () => {
    this.setState({ isHomologarPropietarioModalOpen: true });
  };

  // Cierra el modal de homologación de propietario
  handleCloseHomologarPropietarioModal = () => {
    this.setState({ isHomologarPropietarioModalOpen: false });
  };

  // Callback cuando la homologación de propietario es exitosa
  handleHomologarPropietarioSuccess = () => {
    this.setState({ isHomologarPropietarioModalOpen: false });
    this.refreshPartner();
  };

  getMembershipPreviousMaintenancesList = () => {
    const { previousMaintenancesList } = this.state;

    if ((previousMaintenancesList || []).length == 0) {
      getPartnerMembershipPreviousMaintenances(
        this.props.partner.idMembresiaSocio
      )
        .then(({ data }) => {
          this.setState({ previousMaintenancesList: data });
        })
        .catch(handleRequestError);
    }
  };

  getMembershipDirectMaintenancesList = () => {
    const { directMaintenancesList } = this.state;

    //if (!!this.props.partner.preventa) {
    if ((directMaintenancesList || []).length == 0) {
      getMaintenancesByMembershipForQuotation(
        this.props.partner.idMembresia,
        this.props.partner.idClubBase,
        "AMBOS"
      )
        .then(({ data }) => {
          this.setState({ directMaintenancesList: data });
        })
        .catch(handleRequestError);
    }
    //} else {
    //  this.setState({ directMaintenancesList: [] });
    //}
  };

  getMembershipDirectMembershipList = () => {
    const { directMembershipsList } = this.state;

    if ((directMembershipsList || []).length == 0) {
      getMembershipsTypesByClubAvailableToSellRequest(
        this.props.partner.idClubBase
      )
        .then(({ data }) => {
          this.setState({ directMembershipsList: data });
        })
        .catch(handleRequestError);
    }
  };

  renderNavItem = ({
    activeTabNumber,
    onClick,
    title,
    permisionRequired = null,
    validationsFullfilled = true
  }) => {
    if (this.state.partner && this.state.partner.vetado) {
      const allowedTabsWhenVetado = ["8", "1", "18", "5", "7"];
      if (!allowedTabsWhenVetado.includes(activeTabNumber)) {
        return null;
      }
    }

    const hasPermission = !!permisionRequired
      ? userHasPermission(permisionRequired)
      : true;
    const render = hasPermission && validationsFullfilled;

    return render ? (
      <NavItem>
        <NavLink
          className={`${
            this.state.activeTab === activeTabNumber ? "active" : ""
          } ${s.tab}`}
          onClick={() => {
            this.toggleTab(activeTabNumber);

            if (!!onClick) {
              onClick();
            }
          }}
        >
          {title}
        </NavLink>
      </NavItem>
    ) : null;
  };

  handleSendSelfOnboardingEmail = () => {
    infoNotification("Enviando correo para self onboarding...");
    sendSelfOnboardingMail(this.props.partner.idMembresiaSocio)
      .then(({ data }) => {
        successNotification(
          "Correo para self onboarding enviada correctamente:"
        );
      })
      .catch(handleRequestError);
  };

  handleActivatePartnerMembership = () => {
    infoNotification("Activando...");
    activate(this.props.partner.idMembresiaSocio)
      .then(() => {
        successNotification("Activado correctamente");
        this.refreshPartner();
      })
      .catch(handleRequestError);
  };

  render() {
    const hasNotifications =
      !!this.props.partner &&
      this.props.partner.estatusMembresia == PARTNER_MEMB_ACTIVE_STATUS &&
      (this.props.partner.notificaciones || []).length > 0;
    const canSelfOnBoarding = this.isMembershipBlockedNuevoFlujoVenta();
    const canActivate =
      this.isMembershipBlockedNuevoFlujoVenta() &&
      this.isMembershipBlockedNuevoFlujoVenta() &&
      userHasPermission(
        permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_PARTNER_MEMBERSHIP_ACTIVATE
      );

    return (
      <Container className="p-0 container" fluid>
        {this.props.partner && (
          <ModalFrame
            title="Socio en Black List"
            isOpen={this.state.modalVetadoVisible}
            toggle={() => {
              this.setState({
                modalVetadoVisible: false
              });

              this.toggleTab("8");
            }}
            size="md"
          >
            <Container>
              <div className="alert alert-danger">
                <div style={{ fontWeight: "bold", marginBottom: "16px" }}>
                  Atención: Los siguientes socios se encuntran en Black List. Se
                  prohíbe realizar cualquier tipo de venta a:
                </div>
                {(this.state.sociosVetados || []).map((s, i) => (
                  <div key={"socio_vetado_" + i}>- {s.nombrePersona}</div>
                ))}
              </div>
              <div className="text-right mt-3">
                <Button
                  color="primary"
                  onClick={() => {
                    this.setState({
                      modalVetadoVisible: false
                    });

                    this.toggleTab("8");
                  }}
                >
                  Entendido
                </Button>
              </div>
            </Container>
          </ModalFrame>
        )}

        <ConfirmModal
          title="Cancelación de licencia"
          message="Se cancelará la licencia al momento y se generarán los cargos correspondientes de ser necesario. ¿Desea continuar?"
          isOpen={this.state.licenciaCancelacion}
          ok={async () => {
            try {
              await deleteExtranjerosLicenciaActual(
                this.props.partner.idMembresiaSocio
              );
              this.setState({
                licenciaCancelacion: false
              });

              this.refreshPartner();
            } catch (error) {
              errorNotification("No fue posible pausar la membresía");
            }
          }}
          cancel={() => {
            this.setState({
              licenciaCancelacion: false
            });
          }}
        />

        <ModalFrame
          title={`Oferta comercial para el convenio`}
          isOpen={this.state.modalMttoConvenio}
          toggle={() => this.setState({ modalMttoConvenio: false })}
          size="lg"
        >
          <>
            <Container>
              <div className="alert alert-info">
                Lista de planes disponibles para este convenio:
              </div>
              <Row>
                {this.state.mttoConvenio.map((c, i) => (
                  <Col key={"_mttoconv_" + i} sm={3} md={4}>
                    {c}
                  </Col>
                ))}
              </Row>
            </Container>
          </>
        </ModalFrame>

        <ModalFrame
          title={`${this.state.modalMensajeAlertaTitulo}`}
          isOpen={this.state.modalMensajeAlerta}
          toggle={() =>
            this.setState({
              modalMensajeAlerta: false,
              modalMensajeAlertaMessage: "",
              modalMensajeAlertaTitulo: ""
            })
          }
          size="lg"
        >
          <>
            <Container>
              <div className="">{this.state.modalMensajeAlertaMessage}</div>
            </Container>
          </>
        </ModalFrame>

        <PromotionAssociationModal
          isOpen={this.state.isPromotionAssociationModalOpen}
          partner={this.props.partner}
          promociones={this.state.allowedPromotions}
          cancel={() => {
            this.setState({ isPromotionAssociationModalOpen: false });
          }}
          success={() => {
            this.setState({ isPromotionAssociationModalOpen: false });
            this.refreshPartner();
          }}
        />

        <AlternateClubAssociationModal
          isOpen={this.state.isAlternateClubAssociationModalOpen}
          partner={this.props.partner}
          clubs={this.props.clubs}
          cancel={() => {
            this.setState({ isAlternateClubAssociationModalOpen: false });
          }}
          success={() => {
            this.setState({ isAlternateClubAssociationModalOpen: false });
            this.refreshPartner();
          }}
        />

        {this.props.partner && (
          <HomologarTitularMayorModal
            isOpen={this.state.isHomologarTitularMayorModalOpen}
            idMembresiaSocio={parseInt(this.props.partner.idMembresiaSocio, 10)}
            idTitular={parseInt(this.props.partner.idPersona, 10)}
            onClose={this.handleCloseHomologarTitularModal}
            onSuccess={this.handleHomologarTitularSuccess}
          />
        )}

        {this.props.partner && (
          <HomologarPropietarioModal
            isOpen={this.state.isHomologarPropietarioModalOpen}
            idMembresiaSocio={parseInt(this.props.partner.idMembresiaSocio, 10)}
            idPropietario={parseInt(this.props.partner.idPropietario, 10)}
            onClose={this.handleCloseHomologarPropietarioModal}
            onSuccess={this.handleHomologarPropietarioSuccess}
          />
        )}

        <Row>
          <Col md="4">
            <div className="row mt-3 mb-3">
              <div className="col">
                <p className={`${s.primaryTitle} w-100 m-0`}>
                  Buscar por socio
                </p>
              </div>
            </div>
            <Row>
              <Col>
                <Col>
                  <PartnerSelector setPerson={this.personChanged} />
                </Col>
              </Col>
            </Row>
          </Col>
          <Col md="8">
            <div className="row mt-3 mb-3">
              <div className="col">
                <p className={`${s.primaryTitle} w-100 m-0`}>
                  Buscar por club y número membresía
                </p>
              </div>
            </div>
            <Form
              onSubmit={e => {
                e.preventDefault();
                this.search();
              }}
            >
              <Row>
                <Col>
                  <BaseInput
                    label="Club"
                    name="club"
                    id="club"
                    type="select"
                    value={this.state.filters.idClub}
                    onChange={this.onChangeFilter("idClub")}
                    options={parseArrayToDropdownOptions(
                      this.getOnlyMigratedClubs() || [],
                      "clubId",
                      "nombre"
                    )}
                  />
                </Col>
                <Col>
                  <BaseInput
                    label={"# Membresia"}
                    name={"idMembresiaSocio"}
                    id={"idMembresiaSocio"}
                    placeholder="Id Membresia Socio"
                    value={this.state.filters.idPublico}
                    size="sm"
                    onChange={this.onChangeFilter("idPublico")}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className={`${s.searchButton} ${s.primaryButton} float-right btn-block`}
                    type="submit"
                    disabled={
                      !this.state.filters.idClub ||
                      !this.state.filters.idPublico ||
                      !!this.state.searching
                    }
                  >
                    Buscar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        {this.props.partner &&
          this.props.partner.estatusMembresia ==
            PARTNER_MEMB_TRASPASSED_STATUS &&
          !!this.props.partner.descripcionTraspaso && (
            <div className="p-5 text-center">
              <h5>
                <a href="#" onClick={this.searchTransferredMembership}>
                  {this.props.partner.descripcionTraspaso}
                </a>
              </h5>
            </div>
          )}

        {this.props.partner &&
          this.props.partner.estatusMembresia ==
            PARTNER_MEMB_CANCELLED_STATUS && (
            <div className="p-5 text-center">
              <h5>ELIMINADA</h5>
              <h5>(Revisar detalle de cancelación en bitácora)</h5>
            </div>
          )}

        {!!this.state.licencia && (
          <div className="p-5 text-center">
            <h5>
              Esta membresía tiene activa una licencia de extranjero que
              finalizara en la fecha {this.state.licencia.fechaFin}
            </h5>
            <Button
              size="sm"
              className={`${s.searchButton} ${s.primaryButton}`}
              type="button"
              onClick={e => {
                this.setState({ licenciaCancelacion: true });
              }}
            >
              Cancelar licencia
            </Button>
          </div>
        )}

        {!!this.state.searching && (
          <BasicSpinner
            message={"Consultando datos de la membresía socio"}
            loading={this.state.searching}
          />
        )}

        {this.props.partner &&
          !this.isMembershipBlocked() &&
          !this.state.licencia &&
          this.props.location.search != "" && (
            <Form>
              <Row className="row mt-3 mb-3">
                <Col>
                  <p className={`${s.primaryTitle} w-100 m-0`}>
                    Datos de la Membresía
                  </p>
                </Col>
              </Row>
              <Row>
                <Col
                  sm={12}
                  md={hasNotifications || canSelfOnBoarding ? 9 : 12}
                  lg={hasNotifications || canSelfOnBoarding ? 9 : 12}
                >
                  <Row>
                    {!!this.props.partner.biclub && (
                      <Col sm={6} md={4} lg={3}>
                        <FormGroup>
                          <Label style={{ fontWeight: "bold" }}>
                            Club alterno:
                          </Label>
                          <FormText color="muted">
                            {this.getClubAlternoNombre()}
                            &nbsp;&nbsp;&nbsp;
                            {userHasPermission(
                              permissionCodes.PARTNER_MEMBERSHIP_ASSOCIATE_ALTERNATE_CLUB
                            ) &&
                              !!this.props.partner.biclub && (
                                <BaseButtonWithIconAndTooltip
                                  id={`associate_alternate_club_${this.props.partner.idMembresiaSocio}`}
                                  icon={faPen}
                                  tooltipTitle="Asociar club alterno"
                                  onClick={() => {
                                    this.setState({
                                      isAlternateClubAssociationModalOpen: true
                                    });
                                  }}
                                />
                              )}
                          </FormText>
                        </FormGroup>
                      </Col>
                    )}

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          Tipo de Membresía/Inscripción:
                        </Label>
                        <FormText color="muted">
                          {this.props.partner.nombreMembresia}
                        </FormText>
                      </FormGroup>
                    </Col>

                    {!!this.props.partner.membresiaUpgradeId && (
                      <Col sm={6} md={4} lg={3}>
                        <FormGroup>
                          <Label style={{ fontWeight: "bold" }}>
                            Membresía Upgrade:
                          </Label>
                          <FormText color="muted">
                            {this.props.partner.membresiaUpgradeNombre}
                          </FormText>
                        </FormGroup>
                      </Col>
                    )}

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          Tipo de mantenimiento anterior:
                        </Label>
                        <FormText color="muted">
                          {`${this.props.partner.nombreMantenimiento}`}
                        </FormText>
                      </FormGroup>
                    </Col>

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>Plan:</Label>
                        <FormText color="muted">
                          {!!this.props.partner.mantenimientoPlanNombre
                            ? `${this.props.partner.mantenimientoPlanNombre}`
                            : `${this.props.partner.nombreMantenimiento}`}
                          {!!(
                            this.props.partner.beneficioPrecioClubOrigen || ""
                          ) && (
                            <div className="mt-2">
                              {this.props.partner.beneficioPrecioClubOrigen}
                            </div>
                          )}
                        </FormText>
                      </FormGroup>
                    </Col>
                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          Propietario:
                        </Label>
                        <FormText color="muted">
                          ({this.props.partner.idPropietario}){" "}
                          {this.props.partner.nombrePropietario}
                          &nbsp;&nbsp;&nbsp;
                          <BaseButtonWithIconAndTooltip
                            id={`propietario_editar_${this.props.partner.idPropietario}`}
                            icon={faEdit}
                            tooltipTitle="Editar"
                            onClick={() => {
                              window.open(
                                `/socio/${this.props.partner.idPropietario}/detalle`,
                                "_blank"
                              );
                            }}
                          />
                          &nbsp;&nbsp;&nbsp;
                          {this.shouldShowHomologarPropietarioButton() && (
                            <BaseButtonWithIconAndTooltip
                              id={`propietario_homologar_${this.props.partner.idPropietario}`}
                              icon={faUsers}
                              tooltipTitle="Homologar Propietario"
                              onClick={this.handleHomologarPropietario}
                            />
                          )}
                        </FormText>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>Titular:</Label>
                        <FormText color="muted">
                          ({this.props.partner.idPersona}){" "}
                          {this.props.partner.nombrePersona}
                          &nbsp;&nbsp;&nbsp;
                          <BaseButtonWithIconAndTooltip
                            id={`titular_editar_${this.props.partner.idPersona}`}
                            icon={faEdit}
                            tooltipTitle="Editar"
                            onClick={() => {
                              window.open(
                                `/socio/${this.props.partner.idPersona}/detalle`,
                                "_blank"
                              );
                            }}
                          />
                          &nbsp;&nbsp;&nbsp;
                          {!this.state.estaVetado && (
                            <BaseButtonWithIconAndTooltip
                              id={`titular_carrito_${this.props.partner.idPersona}`}
                              icon={faShoppingCart}
                              tooltipTitle=" Ir a carrito"
                              onClick={() => {
                                this.props.history.push(
                                  `/productos/carrito/${this.props.partner.idPersona}`
                                );
                              }}
                            />
                          )}
                          &nbsp;&nbsp;&nbsp;
                          {this.shouldShowHomologarButton() && (
                            <BaseButtonWithIconAndTooltip
                              id={`titular_homologar_${this.props.partner.idPersona}`}
                              icon={faUsers}
                              tooltipTitle="Homologar"
                              onClick={this.handleHomologarTitular}
                            />
                          )}
                        </FormText>
                      </FormGroup>
                    </Col>

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>Convenio:</Label>
                        <FormText
                          color={
                            this.state.convenioMessage ? "danger" : "muted"
                          }
                        >
                          {this.props.partner.nombreConvenio}
                          {userHasPermission(
                            permissionCodes.PARTNER_MEMBERSHIP_DISASSOCIATE_AGREEMENT
                          ) &&
                            !this.isMembershipBlockedNuevoFlujoVenta() &&
                            !this.isMembershipBlockedPresale() &&
                            !!this.props.partner.idConvenio && (
                              <>
                                <div style={{ display: "inline-block" }}>
                                  <SideActionButton
                                    buttonId={`disassociate_agreement_membership_button`}
                                    tooltipTitle={"Desasociar convenio"}
                                    icon={faBan}
                                    onClick={async () => {
                                      await putDesasociarConvenio(
                                        this.props.partner.idMembresiaSocio
                                      );
                                      this.setState({
                                        convenioMessage: null
                                      });
                                    }}
                                    success={this.search}
                                    confirmModal={{
                                      title: "Desasociar convenio",
                                      message:
                                        "¿Desea desasociar el convenio de la membresía socio?"
                                    }}
                                  />
                                </div>
                              </>
                            )}
                        </FormText>
                        <div
                          style={{
                            color: "#dc3545",
                            fontSize: "14px",
                            marginTop: "4px"
                          }}
                        >
                          {this.state.convenioMessage}
                        </div>
                      </FormGroup>
                    </Col>

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>Promoción:</Label>
                        <FormText color="muted">
                          {this.props.partner.nombrePromocion}
                          &nbsp;&nbsp;&nbsp;
                          {!this.props.partner.nombrePromocion &&
                            userHasPermission(
                              permissionCodes.PARTNER_MEMBERSHIP_ASSOCIATE_PROMOTION
                            ) &&
                            !this.isMembershipBlocked() &&
                            !this.isMembershipBlockedReactivacion() &&
                            !this.isMembershipBlockedNuevoFlujoVenta() && (
                              <BaseButtonWithIconAndTooltip
                                id={`associate_promotion_${this.props.partner.idMembresiaSocio}`}
                                icon={faCheckCircle}
                                tooltipTitle="Asociar promoción"
                                onClick={() => {
                                  const {
                                    idClubBase: club,
                                    idConvenio: convenio,
                                    idMantenimiento: mantenimiento,
                                    idMembresia: membresia
                                  } = this.props.partner;
                                  const params = {
                                    club,
                                    membresia,
                                    mantenimiento,
                                    convenio
                                  };

                                  getPromotionsFilteredRequest(params)
                                    .then(({ data }) => {
                                      if ((data || []).length <= 0) {
                                        errorNotification(
                                          "No existen promociones asociables para la membresía socio"
                                        );
                                      } else {
                                        this.setState({
                                          allowedPromotions: data || [],
                                          isPromotionAssociationModalOpen: true
                                        });
                                      }
                                    })
                                    .catch(handleRequestError);
                                }}
                              />
                            )}
                          {!!this.props.partner.nombrePromocion &&
                            userHasPermission(
                              permissionCodes.PARTNER_MEMBERSHIP_DESASSOCIATE_PROMOTION
                            ) &&
                            !this.isMembershipBlocked() &&
                            !this.isMembershipBlockedReactivacion() &&
                            !this.isMembershipBlockedNuevoFlujoVenta() && (
                              <BaseButtonWithIconAndTooltip
                                id={`desassociate_promotion_${this.props.partner.idMembresiaSocio}`}
                                icon={faBan}
                                tooltipTitle="Desasociar promoción"
                                onClick={() => {
                                  const {
                                    idMembresiaSocio
                                  } = this.props.partner;
                                  infoNotification("Desaplicando promoción...");
                                  associatePromotion(idMembresiaSocio, 0)
                                    .then(() => {
                                      successNotification(
                                        "Promoción desaplicada correctamente"
                                      );
                                      this.refreshPartner();
                                    })
                                    .catch(handleRequestError);
                                }}
                              />
                            )}
                        </FormText>
                      </FormGroup>
                    </Col>

                    {!!this.props.partner.nombrePromocionAlt && (
                      <Col sm={6} md={4} lg={3}>
                        <FormGroup>
                          <Label style={{ fontWeight: "bold" }}>
                            Promoción adicional:
                          </Label>
                          <FormText color="muted">
                            {this.props.partner.nombrePromocionAlt}
                            &nbsp;&nbsp;&nbsp;
                            {!!this.props.partner.nombrePromocionAlt &&
                              userHasPermission(
                                permissionCodes.PARTNER_MEMBERSHIP_DESASSOCIATE_PROMOTION
                              ) &&
                              !this.isMembershipBlocked() &&
                              !this.isMembershipBlockedReactivacion() &&
                              !this.isMembershipBlockedNuevoFlujoVenta() && (
                                <BaseButtonWithIconAndTooltip
                                  id={`desassociate_promotion_alt_${this.props.partner.idMembresiaSocio}`}
                                  icon={faBan}
                                  tooltipTitle="Desasociar promoción adicional"
                                  onClick={() => {
                                    const {
                                      idMembresiaSocio
                                    } = this.props.partner;
                                    infoNotification(
                                      "Desaplicando promoción adicional..."
                                    );
                                    associateAltPromotion(idMembresiaSocio, "0")
                                      .then(() => {
                                        successNotification(
                                          "Promoción adicional desaplicada correctamente"
                                        );
                                        this.refreshPartner();
                                      })
                                      .catch(handleRequestError);
                                  }}
                                />
                              )}
                          </FormText>
                        </FormGroup>
                      </Col>
                    )}

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>Estatus:</Label>
                        <FormText color="muted">
                          {!!this.isMembershipBlockedPresale() &&
                          this.props.partner.estatusMembresia ==
                            PARTNER_MEMB_ACTIVE_STATUS
                            ? "PREVENTA"
                            : this.props.partner.estatusMembresia}
                          {userHasPermission(
                            permissionCodes.PARTNER_MEMBERSHIP_CHANGE_STATUS
                          ) &&
                            !this.isMembershipBlockedPresale() &&
                            (this.props.partner.estatusMembresia ==
                              PARTNER_MEMB_ACTIVE_STATUS ||
                              this.props.partner.estatusMembresia ==
                                PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS) &&
                            renderChangeStatusButton(
                              this.props.partner.idMembresiaSocio,
                              PARTNER_MEMB_INACTIVE_STATUS,
                              `inactivate_membership_button`,
                              "Desactivar membresía socio",
                              faBan,
                              this.search
                            )}
                          {userHasPermission(
                            permissionCodes.PARTNER_MEMBERSHIP_CHANGE_STATUS
                          ) &&
                            !this.isMembershipBlockedPresale() &&
                            (this.props.partner.estatusMembresia ==
                              PARTNER_MEMB_INACTIVE_STATUS ||
                              this.props.partner.estatusMembresia ==
                                PARTNER_MEMB_PASIVE_STATUS) &&
                            renderChangeStatusButton(
                              this.props.partner.idMembresiaSocio,
                              PARTNER_MEMB_ACTIVE_STATUS,
                              `activate_membership_button`,
                              "Activar membresía socio",
                              faCheckCircle,
                              this.search
                            )}
                        </FormText>
                      </FormGroup>
                    </Col>

                    <Col sm={6} md={4} lg={3}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          <span
                            style={{
                              color: this.props.partner.fechaAdquisicion
                                ? null
                                : "#A00"
                            }}
                          >
                            Fecha de Adquisición:
                            <br />
                          </span>
                        </Label>
                        {this.props.partner.fechaAdquisicion ? (
                          <FormText color="muted">
                            {moment(this.props.partner.fechaAdquisicion).format(
                              "DD/MM/YYYY"
                            )}
                          </FormText>
                        ) : (
                          <>
                            <div
                              style={{
                                display: "inline-block",
                                maxWidth: "200px"
                              }}
                            >
                              <DatePicker
                                name="fechaNacimiento"
                                id="fechaNacimiento"
                                selected={this.state.fechaAdquisicion}
                                onChange={evt => {
                                  this.setState({
                                    fechaAdquisicion: evt
                                  });
                                }}
                              />
                            </div>
                            <a
                              id="fda0001"
                              className="ml-3"
                              style={{
                                cursor: "pointer",
                                display: "inline-block",
                                color: "#888"
                              }}
                              onClick={async e => {
                                e.preventDefault();

                                if (!this.state.fechaAdquisicion) {
                                  errorNotification(
                                    "Debe seleccionar una fecha"
                                  );
                                  return;
                                }

                                infoNotification(
                                  "Guardando fecha de adquisición..."
                                );

                                try {
                                  await axios.post(
                                    `${constants.BASE_URL}/api/memberships/buy-date`,
                                    null,
                                    {
                                      withCredentials: true,
                                      params: {
                                        idMembresiaSocio: this.props.partner
                                          .idMembresiaSocio,
                                        fecha: moment(
                                          this.state.fechaAdquisicion
                                        ).format("YYYY-MM-DD")
                                      }
                                    }
                                  );

                                  successNotification(
                                    "Fecha de adquisición guardada correctamente"
                                  );
                                } catch (error) {
                                  const message =
                                    (error &&
                                      error.response &&
                                      error.response.data &&
                                      error.response.data.message) ||
                                    "Error al guardar la fecha de adquisición";
                                  errorNotification(message);
                                }
                              }}
                            >
                              <FontAwesomeIcon icon={faSave} />
                              <UncontrolledTooltip
                                placement="top"
                                target="fda0001"
                              >
                                Guardar fecha
                              </UncontrolledTooltip>
                            </a>
                          </>
                        )}
                      </FormGroup>
                    </Col>

                    <Col></Col>
                  </Row>
                </Col>

                {hasNotifications && (
                  <Col sm={12} md={3} lg={3}>
                    <Label style={{ fontWeight: "bold" }}>
                      Notificaciones:
                    </Label>
                    <div>
                      {((this.props.partner || {}).notificaciones || []).map(
                        notificacion => {
                          return (
                            <div
                              className={
                                "alert alert-" +
                                (this.props.partner.impedimentoAcceso
                                  ? "danger"
                                  : "warning")
                              }
                              style={{
                                fontSize: "0.8em",
                                fontWeight: this.props.partner.impedimentoAcceso
                                  ? "bold"
                                  : "normal"
                              }}
                            >
                              {notificacion}
                            </div>
                          );
                        }
                      )}
                    </div>
                  </Col>
                )}

                {(canSelfOnBoarding || canActivate) && (
                  <Col sm={12} md={3} lg={3}>
                    {canSelfOnBoarding && (
                      <div className="text-center">
                        <Button
                          className="bg-secondary mr-4 mt-4"
                          size="md"
                          block
                          onClick={this.handleSendSelfOnboardingEmail}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                          <span className="ml-2">
                            {" "}
                            Enviar correo para Self-Onboarding
                          </span>
                        </Button>
                      </div>
                    )}

                    {canActivate && (
                      <div className="text-center">
                        <Button
                          className="bg-success mr-4 mt-4"
                          size="md"
                          block
                          onClick={this.handleActivatePartnerMembership}
                        >
                          <FontAwesomeIcon icon={faCheckCircle} />
                          <span className="ml-2"> Activar</span>
                        </Button>
                      </div>
                    )}
                  </Col>
                )}
              </Row>
            </Form>
          )}
        <hr />

        {this.state.estaVetado && (
          <div className="alert alert-danger">
            <div style={{ fontWeight: "bold", marginBottom: "16px" }}>
              Atención: Los siguientes socios se encuntran en Black List. Se
              prohíbe realizar cualquier tipo de venta a:
            </div>
            {(this.state.sociosVetados || []).map((s, i) => (
              <div key={"socio_vetado_" + i}>- {s.nombrePersona}</div>
            ))}
          </div>
        )}

        {this.props.partner && !!this.props.partner.descuentosAlDia && (
          <div className="m-5">
            Descuentos planes:
            <span className="ml-3">{this.props.partner.descuentosAlDia}</span>
          </div>
        )}

        {this.props.partner &&
          this.props.location.search != "" &&
          !this.state.licencia && (
            <Container
              className="w-100 p-0 m-0"
              style={{ height: "650px" }}
              xs={12}
            >
              <Nav className={s.tabs} tabs>
                {this.renderNavItem({
                  activeTabNumber: "1",
                  onClick: null,
                  title: "Socios",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_PARTNERS
                })}

                {this.renderNavItem({
                  activeTabNumber: "2",
                  onClick: null,
                  title: "Documentos",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_DOCUMENTS,
                  validationsFullfilled: !this.isMembershipPendienteStatus()
                })}

                {this.renderNavItem({
                  activeTabNumber: "3",
                  onClick: () => {
                    this.getSurveyTypes();
                  },
                  title: "Encuestas",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_SURVEYS,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "5",
                  onClick: () => {
                    this.getPaymentMethods();
                  },
                  title: "Tokenización",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_TOKEN,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    (!this.isMembershipBlockedReactivacion() ||
                      userHasPermission(
                        permissionCodes.PARTNER_MEMBERSHIP_TAB_TOKEN_ALLOW_REACTIVATE_PAYMENT_METHOD
                      ))
                })}

                {this.renderNavItem({
                  activeTabNumber: "6",
                  onClick: () => {
                    this.getCurrentQuote();
                    this.getCurrentAgreements();
                    this.getMembershipPreviousMaintenancesList();
                    this.getMembershipDirectMaintenancesList();
                    this.getMembershipDirectMembershipList();
                  },
                  title: "Trámites",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM,
                  validationsFullfilled: !this.isMembershipBlocked()
                })}

                {this.renderNavItem({
                  activeTabNumber: "7",
                  onClick: () => {
                    this.getMovements();
                    this.getAnnuitiesAvailableMaintenaces();
                  },
                  title: "Movimientos",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS
                })}

                {/*REQUERIMIENTO: REPORTE DETALLE MANTENIMIENTOS*/}
                {this.renderNavItem({
                  activeTabNumber: "21",
                  onClick: () => {
                    this.getMembershipMaintenancesDetail();
                  },
                  title: "Cargos asociados al plan",
                  validationsFullfilled: !this.isMembershipBlockedNuevoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "8",
                  onClick: () => {
                    this.getPartnerMembershipMessages();
                  },
                  title: "Mensajes",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_MESSAGES,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedNuevoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "9",
                  onClick: () => {},
                  title: "Adelantados",
                  permisionRequired: permissionCodes.PARTNER_MEMBERSHIP_TAB_ADE,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isMembershipBlockedPresale() &&
                    !this.isFriendsAndFamilyPromotion()
                })}

                {this.props.partner &&
                  this.props.partner.estatusMembresia != "ACTIVA" &&
                  this.renderNavItem({
                    activeTabNumber: "10",
                    onClick: null,
                    title: "Reactivación",
                    permisionRequired:
                      permissionCodes.PARTNER_MEMBERSHIP_TAB_REACTIVATION,
                    validationsFullfilled:
                      !this.isMembershipBlocked() &&
                      !this.isMembershipBlockedNuevoFlujoVenta() &&
                      !this.isMembershipBlockedPresale()
                  })}

                {this.renderNavItem({
                  activeTabNumber: "25",
                  onClick: null,
                  title: "Recotización",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_REACTIVATION,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    this.isMembershipBlockedNuevoFlujoVenta() &&
                    this.isMembershipTipoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "11",
                  onClick: () => {
                    this.getPartnersClubAccessInfoXX();
                  },
                  title: "Accesos",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_ACCESS,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedNuevoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "12",
                  onClick: () => {
                    this.getAutomaticChargesRecord();
                  },
                  title: "Histórico CAT",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_CAT_HIST,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isMembershipBlockedPresale()
                })}

                {this.renderNavItem({
                  activeTabNumber: "14",
                  onClick: () => {
                    this.getAnnuitiesAvailableMaintenaces();
                    this.getAnnuitiesUsers();
                  },
                  title: "Anualidades",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_ANNUITIES,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    (!this.isMembershipBlockedNuevoFlujoVenta() ||
                      (!!this.isMembershipBlockedNuevoFlujoVenta() &&
                        this.isMembershipPendienteConAnualidadStatus())) &&
                    !this.isFriendsAndFamilyPromotion()
                })}

                {this.renderNavItem({
                  activeTabNumber: "15",
                  onClick: () => {
                    this.getMembershipDiscountCodes();
                  },
                  title: "Códigos de descuento",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_DISCOUNT_CODES,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta()
                })}

                {this.renderNavItem({
                  activeTabNumber: "19",
                  onClick: null,
                  title: "Descuentos directos",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_DISCOUNT_CODES,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isFriendsAndFamilyPromotion()
                })}

                {/*REQUERIMIENTO: CUOTA VACACIONAL*/}
                {this.renderNavItem({
                  activeTabNumber: "20",
                  onClick: () => {
                    this.getMembershipVacationFees();
                  },
                  title: "Cuotas vacacionales",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_VACATION_FEE,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isMembershipBlockedPresale()
                })}

                {/*REQUERIMIENTO: REFERIDOS*/}
                {this.renderNavItem({
                  activeTabNumber: "22",
                  onClick: () => {
                    this.getMembershipReferredCodesDetail();
                    this.getMembershipReferredDetail();
                  },
                  title: "Referidos",
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isFriendsAndFamilyPromotion()
                })}

                {/*REQUERIMIENTO: LICENCIA DE EXTRANJEROS*/}
                {this.renderNavItem({
                  activeTabNumber: "23",
                  onClick: null,
                  title: "Licencia extranjeros",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_LICENCIA_EXTRANJERO,
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isMembershipBlockedPresale() &&
                    this.state.extranjeros &&
                    !!this.state.extranjeros.length
                })}

                {this.renderNavItem({
                  activeTabNumber: "24",
                  onClick: () => {
                    this.getFitKidzEvidencesList();
                    this.getFitKidzDiscountsCodesList();
                  },
                  title: "FitKidz",
                  validationsFullfilled:
                    !this.isMembershipBlocked() &&
                    !this.isMembershipBlockedReactivacion() &&
                    !this.isMembershipBlockedNuevoFlujoVenta() &&
                    !this.isMembershipBlockedPresale() &&
                    !!this.props.partner.esFitKidz
                })}

                {this.renderNavItem({
                  activeTabNumber: "18",
                  onClick: null,
                  title: "Bitácora",
                  permisionRequired:
                    permissionCodes.PARTNER_MEMBERSHIP_TAB_BINNACLE
                })}
              </Nav>

              <TabContent className="h-100" activeTab={this.state.activeTab}>
                <div></div>

                {/*SOCIOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_PARTNERS
                ) &&
                  this.props.partner &&
                  this.props.partnersMembership && (
                    <TabPartners
                      history={this.props.history}
                      partner={this.props.partner}
                      filters={this.state.filters}
                      partnersMembership={this.props.partnersMembership}
                      descripcionTraspaso={
                        this.props.partner.descripcionTraspaso
                      }
                      membershipTypesMembers={this.props.membershipTypesMembers}
                      toggleAddPartner={this.props.toggleAddPartner}
                      toggleAddFreePartner={this.props.toggleAddFreePartner}
                      toggleChangeFreePartner={
                        this.props.toggleChangeFreePartner
                      }
                      toggleAddFreeChildPartner={
                        this.props.toggleAddFreeChildPartner
                      }
                      getMembershipMembers={this.props.getMembershipMembers}
                      updatePhoto={this.props.updatePhoto}
                      updatePawPrint={this.props.updatePawPrint}
                      accessRegister={this.props.accessRegister}
                      getPartnersMembership={this.props.getPartnersMembership}
                      toggleDeletePartner={this.props.toggleDeletePartner}
                      titularUpdated={() => {
                        this.search();
                      }}
                      invalidateStateValue={this.invalidateStateValue}
                      executePartnerMembershipPartners={
                        this.props.executePartnerMembershipPartners
                      }
                      refreshPartner={this.refreshPartner}
                      membershipBlocked={this.isMembershipBlocked()}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                      membershipBlockedNuevoFlujoVenta={this.isMembershipBlockedNuevoFlujoVenta()}
                    />
                  )}

                {/*DOCUMENTOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_DOCUMENTS
                ) &&
                  this.props.partner &&
                  this.props.partnersMembership && (
                    <TabDocuments
                      partner={this.props.partner}
                      activeTab={this.state.activeTab}
                      descripcionTraspaso={
                        this.props.partner.descripcionTraspaso
                      }
                      membershipBlocked={
                        this.isMembershipBlocked() ||
                        this.isMembershipBlockedReactivacion() ||
                        this.isMembershipPendienteStatus()
                      }
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                      refreshPartner={this.refreshPartner}
                      procesoVenta={this.isMembershipBlockedNuevoFlujoVenta()}
                    />
                  )}

                {/*ENCUESTAS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_SURVEYS
                ) &&
                  this.props.partner &&
                  this.state.surveyTypes &&
                  this.props.partnersMembership && (
                    <TabSurveys
                      members={this.props.partnersMembership}
                      surveyTypes={this.state.surveyTypes}
                      saveAnswers={this.props.saveAnswers}
                      idMembresiaSocio={this.props.partner.idMembresiaSocio}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                    />
                  )}

                {/*MEDIOS DE PAGO*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_TOKEN
                ) &&
                  this.props.partner && (
                    <TabBankCards
                      partner={this.props.partner}
                      idMembresiaSocio={this.props.partner.idMembresiaSocio}
                      paymentMethods={this.state.paymentMethods}
                      clubs={this.props.clubs}
                      getPaymentMethods={this.getPaymentMethods}
                      deleteBankCard={this.props.deleteBankCard}
                      refreshPartner={this.refreshPartner}
                      invalidateStateValue={this.invalidateStateValue}
                      membershipBlockedReactivacion={
                        this.isMembershipBlockedReactivacion() ||
                        this.isMembershipBlockedNuevoFlujoVenta()
                      }
                      estaVetado={this.state.estaVetado}
                    />
                  )}

                {/*TRAMITES*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM
                ) &&
                  this.props.partner && (
                    <TabTransact
                      activeTab={this.state.activeTab}
                      partner={this.props.partner}
                      quotations={this.props.quotations}
                      match={this.props.match}
                      history={this.props.history}
                      agreements={this.state.currentAgreements}
                      successfullSwitchMembership={
                        this.props.successfullSwitchMembership
                      }
                      actualQuote={this.state.actualQuote}
                      clubs={this.getOnlyMigratedClubs()}
                      getActualQuote={this.getCurrentQuote}
                      getQuotations={this.props.getQuotations}
                      rightsChange={this.props.rightsChange}
                      refreshPartner={this.refreshPartner}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                      previousMaintenancesList={
                        this.state.previousMaintenancesList || []
                      }
                      directMaintenancesList={
                        this.state.directMaintenancesList || []
                      }
                      directMembershipList={
                        this.state.directMembershipsList || []
                      }
                    />
                  )}

                {/*MOVIMIENTOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS
                ) &&
                  this.props.partner && (
                    <TabMovements
                      partner={this.props.partner}
                      movementsList={this.state.movementsList}
                      idMembresia={this.props.partner.idMembresia}
                      idMembresiaSocio={this.props.partner.idMembresiaSocio}
                      listHistoricalRebilling={
                        this.props.listHistoricalRebilling
                      }
                      sendMovementEmail={this.props.sendMovementEmail}
                      toggleBill={this.props.toggleBill}
                      toggleBillXml={this.props.toggleBillXml}
                      getMovements={this.getMovements}
                      historicalRebilling={this.props.historicalRebilling}
                      invalidateStateValue={this.invalidateStateValue}
                      refreshPartner={this.refreshPartner}
                      descripcionTraspaso={
                        this.props.partner.descripcionTraspaso
                      }
                      membershipBlocked={
                        this.isMembershipBlocked() ||
                        this.isMembershipBlockedNuevoFlujoVenta() ||
                        this.isMembershipBlockedPresale()
                      }
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                      estaVetado={this.state.estaVetado}
                      annuitiesAvailableMaintenances={
                        this.state.annuitiesAvailableMaintenances
                      }
                    />
                  )}

                {/*MENSAJES*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MESSAGES
                ) &&
                  this.props.partner && (
                    <TabMessages
                      idMembresiaSocio={this.props.partner.idMembresiaSocio}
                      messagesByMembresia={this.state.messagesByMembresia}
                      partnersMembership={this.props.partnersMembership}
                      getMessages={this.getPartnerMembershipMessages}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                    />
                  )}

                {/*ADELANTADOS*/
                userHasPermission(permissionCodes.PARTNER_MEMBERSHIP_TAB_ADE) &&
                  this.props.partner &&
                  !this.isFriendsAndFamilyPromotion() && (
                    <TabPayments
                      partner={this.props.partner}
                      currentMembershipPartners={(
                        this.props.partnersMembership || []
                      ).filter(x => !x.esInvitadoGratis)}
                      currentMembershipConfiguration={this.props.partner}
                      invalidateStateValue={this.invalidateStateValue}
                      refreshPartner={this.refreshPartner}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                    />
                  )}

                {/*REACTIVACIONES*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_REACTIVATION
                ) &&
                  this.props.partner &&
                  this.props.partner.estatusMembresia != "ACTIVA" && (
                    <TabReactivation
                      history={this.props.history}
                      partner={this.props.partner}
                      quotations={this.props.quotations}
                      getQuotations={this.props.getQuotations}
                      activeTab={this.state.activeTab}
                      refreshPartner={this.refreshPartner}
                    />
                  )}

                {/*RECOTIZACION*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_REACTIVATION
                ) &&
                  this.props.partner && (
                    <TabRequotation
                      history={this.props.history}
                      partner={this.props.partner}
                      quotations={this.props.quotations}
                      getQuotations={this.props.getQuotations}
                      activeTab={this.state.activeTab}
                      refreshPartner={this.refreshPartner}
                    />
                  )}

                {/*ACCESOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_ACCESS
                ) && (
                  <TabPartnersIngress
                    partner={this.props.partner}
                    activeTab={this.state.activeTab}
                    partnersClubAccessInfo={this.state.partnersClubAccessInfo}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/*HISTORIAL CARGOS AUTOMATICOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_CAT_HIST
                ) && (
                  <TabHistoryAutCharge
                    listHistoryAutCharges={this.state.listHistoryAutCharges}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/*ANUALIDADES*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_ANNUITIES
                ) &&
                  !this.isFriendsAndFamilyPromotion() && (
                    <TabAnnuitiesQuote
                      partner={this.props.partner}
                      annuitiesAvailableMaintenances={
                        this.state.annuitiesAvailableMaintenances
                      }
                      currentMembershipPartners={(
                        this.props.partnersMembership || []
                      ).filter(x => !x.esInvitadoGratis)}
                      currentMembershipConfiguration={this.props.partner}
                      users={this.state.users}
                      clubs={this.getOnlyMigratedClubs()}
                      history={this.props.history}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                      refreshPartner={this.refreshPartner}
                    />
                  )}

                {/*CODIGOS DE DESCUENTO*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_DISCOUNT_CODES
                ) && (
                  <TabDiscountCodes
                    discountCodes={this.state.discountCodes}
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    invalidateStateValue={this.invalidateStateValue}
                    getMembershipDiscountCodes={this.getMembershipDiscountCodes}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/*DESCUENTOS DIRECTOS*/
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_DISCOUNT_CODES
                ) &&
                  !this.isFriendsAndFamilyPromotion() && (
                    <TabDescuentosDirectos
                      partner={this.props.partner}
                      activeTab={this.state.activeTab}
                      membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                    />
                  )}

                {/* HISTORIAL DE MOVIMIENTOS EN CRM1 */
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS
                ) && (
                  <TabHistoryCrm1
                    persons={this.props.partnersMembership}
                    activeTab={this.state.activeTab}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/* BITACORA */
                userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_BINNACLE
                ) && (
                  <TabBinnacle
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    idPersona={this.props.partner.idPersona}
                    activeTab={this.state.activeTab}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS
                ) && (
                  <TabBenefitsCrm1
                    crm1Benefits={this.state.crm1BenefitsList}
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    invalidateStateValue={this.invalidateStateValue}
                    getCrm1Benefits={this.getCrm1Benefits}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/*REQUERIMIENTO: CUOTA VACACIONAL*/}
                {userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_VACATION_FEE
                ) && (
                  <TabVacationFees
                    vacationFees={this.state.vacationFees}
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    invalidateStateValue={this.invalidateStateValue}
                    getMembershipVacationFees={this.getMembershipVacationFees}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}

                {/*REQUERIMIENTO: REPORTE DETALLE MANTENIMIENTOS*/}
                <TabMaintenancesDetailReport
                  maintenancesDetail={this.state.maintenancesDetail}
                  idMembresiaSocio={this.props.partner.idMembresiaSocio}
                  searching={this.state.maintenancesDetailSearching}
                  invalidateStateValue={this.invalidateStateValue}
                  getMembershipMaintenancesDetail={
                    this.getMembershipMaintenancesDetail
                  }
                  membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                />

                {/*REQUERIMIENTO: REFERIDOS*/}
                {!this.isFriendsAndFamilyPromotion() && (
                  <TabReferred
                    referredCodesDetail={this.state.referredCodesDetail}
                    referredDetail={this.state.referredDetail}
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    clubs={this.props.clubs}
                    invalidateStateValue={this.invalidateStateValue}
                    createReferredCodes={this.createMembershipReferredCodes}
                    deleteReferredCode={this.deleteMembershipReferredCode}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                    getMembershipReferredDetail={
                      this.getMembershipReferredDetail
                    }
                    getMembershipReferredCodesDetail={
                      this.getMembershipReferredCodesDetail
                    }
                  />
                )}

                {/*REQUERIMIENTO: Licencia de extranjeros*/}
                <TabLicenciaExtranjeros
                  idMembresiaSocio={this.props.partner.idMembresiaSocio}
                  activeTab={this.state.activeTab}
                  membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                />

                {!!this.props.partner.esFitKidz && (
                  <TabFitKidz
                    idMembresiaSocio={this.props.partner.idMembresiaSocio}
                    activeTab={this.state.activeTab}
                    evidenceList={this.state.fitKidzEvidencesList}
                    getEvidences={this.getFitKidzEvidencesList}
                    fitKidzDiscountsCodesList={
                      this.state.fitKidzDiscountsCodesList
                    }
                    getDiscountCodes={this.getFitKidzDiscountsCodesList}
                    invalidateStateValue={this.invalidateStateValue}
                    refreshPartner={this.refreshPartner}
                    esFitKidzPorCaducar={this.props.partner.esFitKidzPorCaducar}
                    membershipBlockedReactivacion={this.isMembershipBlockedReactivacion()}
                  />
                )}
              </TabContent>
            </Container>
          )}
      </Container>
    );
  }
  getClubAlternoNombre() {
    return (
      (
        (this.props.clubs || []).find(
          club => club.clubId == (this.props.partner.idClubAlterno || 0)
        ) || {}
      ).nombre || ""
    );
  }
}

export default withRouter(withStyles(s)(Partners));
